import styled from 'styled-components';
import { BoxMixin } from '../../mixins/components/BoxMixin';
export var StyledBox = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledBox",
  componentId: "c11n-8-111-1__sc-ocjv7k-0"
})(["", ""], BoxMixin);